"use strict";

import angular, { isArray } from "angular";
import { toForm } from "../mapper/mapper";
import {
  createHash,
  createDetachedSignature,
} from "../../../crypto-pro/crypto-pro";

/**
 * @author Maxim Seredkin
 * @param {*} $scope
 * @param {*} $routeParams
 * @param {*} $location
 * @param {*} $rootScope
 * @param {*} $timeout
 * @param {*} ProjectService
 * @param {*} $security
 * @param {*} OrgService
 * @param {*} ModalService
 * @param {*} StaffService
 * @param {*} Notification
 * @param {*} $log
 */
export default [
  "$scope",
  "$routeParams",
  "$location",
  "$rootScope",
  "$timeout",
  "ProjectService",
  "$security",
  "OrgService",
  "ModalService",
  "StaffService",
  "Notification",
  "$log",
  "$q",
  "ProjectUtils",
  "InvestActivityService",
  "Upload",
  "SignService",
  function (
    $scope,
    $routeParams,
    $location,
    $rootScope,
    $timeout,
    ProjectService,
    $security,
    OrgService,
    ModalService,
    StaffService,
    Notification,
    $log,
    $q,
    ProjectUtils,
    InvestActivityService,
    Upload,
    SignService
  ) {
    let enableEdit = false;
    let isLoaded = false;

    $scope.cancel = cancel;
    $scope.save = save;
    $scope.editing = editing;
    $scope.showEditButton = showEditButton;
    $scope.showPartialEditButton = showPartialEditButton;
    $scope.sec = $security;
    $scope.title = "";
    $scope.editingPartial = () => {
      $scope.partialEdit = true;
    };
    $scope.signErrors = [];
    $scope.checkIsChanged = checkIsChanged;

    $scope.getMonth = getMonth;

    $scope.months = [
      {
        id: 1,
        name: "Январь",
      },
      {
        id: 2,
        name: "Февраль",
      },
      {
        id: 3,
        name: "Март",
      },
      {
        id: 4,
        name: "Апрель",
      },
      {
        id: 5,
        name: "Май",
      },
      {
        id: 6,
        name: "Июнь",
      },
      {
        id: 7,
        name: "Июль",
      },
      {
        id: 8,
        name: "Август",
      },
      {
        id: 9,
        name: "Сентябрь",
      },
      {
        id: 10,
        name: "Октябрь",
      },
      {
        id: 11,
        name: "Ноябрь",
      },
      {
        id: 12,
        name: "Декабрь",
      },
    ];

    $scope.signErrors = ["Не указано", "Не подписан", "Подписан"];

    $scope.getSignErrors = function () {
      return (
        "Для подписания проекта необходимо заполнить следующие поля:" +
        ($scope.signErrors ?? []).map((error) => `\n- ${error}`).join("")
      );
    };

    // Маппинг сертификатов бэкенда в нужную форму для показа в слайдере
    function mapBackCerts(item) {
      return {
        thumbprint: item.token,
        owner: item.accessor,
        validFrom: item.from,
        validTo: item.to,
        validToLocaleString: new Date(item.to).toLocaleDateString("ru", {
          year: "numeric",
          month: "numeric",
          day: "numeric",
        }),
        status: convertDateToStatus(item.to),
      };
    }
    // Маппинг сертификатов хранилища в нужную форму для показа в слайдере
    function convertDateToStatus(dateString) {
      const currentDate = new Date();
      const expiredDate = new Date(dateString);
      // Если осталось больше месяца
      if (expiredDate - currentDate > 2629743833.3) return "valid";
      // Если протух
      if (expiredDate - currentDate < 0) return "expired";
      return "ends";
    }

    async function fetchBackCertificates() {
      try {
        const backCertificates = await SignService.api.certificates().$promise;
        $scope.certsLoading = false;
        if (!Array.isArray(backCertificates._embedded)) return;
        $scope.certs = backCertificates._embedded.map(mapBackCerts);
        $scope.selectedCert = $scope.certs[0] || null;
        $scope.$apply();
      } catch (err) {
        $scope.certsLoading = false;
        console.log(err);
        $scope.$apply();
      }
    }

    $scope.processSign = async function processSign() {
      try {
        const thumbprint = $scope.selectedCert.thumbprint;

        const signHash = await createHash($scope.project.hash, "string");
        const signature = await createDetachedSignature(thumbprint, signHash);

        const result = {
          id: $scope.project.id,
          sign: signature.replace(/\r|\n/g, ""),
        };

        const response = await SignService.api.sign(null, {
          token: thumbprint,
          signs: result,
        }).$promise;
        if (
          response._embedded &&
          Array.isArray(response._embedded.signs) &&
          response._embedded.signs.some((item) => item.result)
        ) {
          init();
        } else {
          $scope.$apply();
        }
      } catch (err) {
        Notification.danger({
          title: "Ошибка!",
          message: err.toString(),
        });
        $scope.$apply();
      }
    };

    $scope.formatSignDate = (dateString) =>
      dateString ? new Date(dateString).toLocaleString() : "Не указано";
    $scope.ranksDivider = (num) => (num ? num.toLocaleString() : 0);

    /**
     * Получить месяц
     * @param {*} index
     * @return {string}
     */
    function getMonth(index) {
      let mth = $scope.months.find((month) => month.id == index);
      if (mth) {
        return mth.name;
      } else {
        return "";
      }
    }

    function getSignErrors() {
      ProjectService.api.getEnableSigning(
        { projectId: $routeParams.projectId },
        (data) => {
          if (data._embedded === null) {
            $scope.canSign = false;
            $scope.signErrors = [];
            return;
          }
          $scope.signErrors = angular.copy(data._embedded);
          $scope.canSign = true;
        }
      );
    }

    init();

    // region Function

    /**
     * Инициализация
     */
    function init() {
      $scope.edit = false;
      $scope.partialEdit = false;
      $scope.oldProject = {};
      $scope.project = {};
      $scope.loading = true;
      $scope.changedFields = {};

      fetchBackCertificates();

      if ($routeParams.projectId) {
        isEnableEdit();
        const transactionId = ProjectService.getTransactionId();
        if (transactionId) {
          ProjectService.api.changes(
            { projectId: $routeParams.projectId },
            null,
            (data) => {
              for (let key in data) {
                if (data[key] !== null) {
                  $scope.changedFields[key] = data[key];
                }
              }
            }
          );
          // $scope.changedFields = itemChanges;
        }

        getSignErrors();

        ProjectService.api.get(
          { projectId: $routeParams.projectId },
          (data) => {
            if (data._embedded === null) {
              $location.url("projects");
            }
            $scope.project = angular.copy(data._embedded);

            processProfitWorkPlaces($scope.project);
            if (
              $scope.project.projectStatus != null &&
              $scope.project.projectStatus.transitionDate != null
            ) {
              $scope.project.projectStatus.transitionDate = new Date(
                $scope.project.projectStatus.transitionDate
              );
            }

            load();
          }
        );
      } else {
        $location.url("projects");
      }
    }

    function checkIsChanged(prop, nextValue, prevValue, config) {
      //console.log(prop, nextValue, prevValue, config);
      if (prop in $scope.changedFields) {
        // if (config) {
        //     if (config.isArray && JSON.stringify(nextValue) !== JSON.stringify(prevValue)) {
        //         console.log(prop, 'true')
        //         return true;
        //     }
        //     //console.log(config.isDictionary, nextValue && nextValue.name, prevValue && prevValue.name)
        //     if (config.isDictionary && ((nextValue && nextValue.name) !== (prevValue && prevValue.name))) {
        //         return true;
        //     }
        // } else if (nextValue !== prevValue) {
        //     return true;
        // }
        return true;
      }
      return false;
    }

    /**
     * Режим редактирования?
     */
    function isEnableEdit() {
      ProjectService.api.enableUpdate(
        {
          projectId: $routeParams.projectId,
          transactionId: ProjectService.getTransactionId(),
        },
        (data) => {
          enableEdit = data._embedded;
        }
      );
    }

    /**
     * Показать кнопку редактирования
     * @return {boolean|*}
     */
    function showEditButton() {
      return (
        isLoaded &&
        enableEdit &&
        !$scope.edit &&
        $security.isAllowWrite("/projects/:projectId", "all")
      );
    }

    function showPartialEditButton() {
      return (
        isLoaded &&
        enableEdit &&
        !$scope.partialEdit &&
        $security.isAllowWrite("/projects/:projectId", "partial")
      );
    }

    /**
     * Включить режим редактирования
     */
    function editing() {
      $scope.edit = true;
    }

    $scope.uploadFile = function (file) {
      if (file) {
        Upload.upload({
          url: "api/attachments/upload",
          data: {
            file: file,
          },
        })
          .then(function (response) {
            $scope.oldProject = angular.copy($scope.project);
            $scope.project.imageAttachment = {id: response.data._embedded.id};
            save();
          })
          .catch(function (error) {
            Notification.warning({
              title: "Внимание!",
              message: "Ошибка при загрузке файла",
            });
            console.error("Ошибка загрузки файла:", error);
          });
      }
    };

    /**
     * Загрузить
     */
    async function load() {
      $scope.project.projectTaxes = [];
      $scope.project.projectWorkPlaces = [];
      let [
        statuses,
        projectContacts,
        projectFactFunds,
        projectPlanFunds,
        projectTaxes,
        projectWorkPlaces,
        projectPlanFundsByYear,
        projectFactFundsByYear,
        projectLands,
        projectMaintenanceKinds,
        projectMaintenances,
        projectOkveds,
        projectOutputs,
        projectProgresses,
        projectSubProgresses,
        chronologies,
        projectSupports,
        investActivityArea,
      ] = await $q.all([
        ProjectService.api.status({ projectId: $routeParams.projectId })
          .$promise,
        ProjectService.api.contacts({ projectId: $routeParams.projectId })
          .$promise,
        ProjectService.api.factFunds({ projectId: $routeParams.projectId })
          .$promise,
        ProjectService.api.planFunds({ projectId: $routeParams.projectId })
          .$promise,
        ProjectService.api.taxes({ projectId: $routeParams.projectId })
          .$promise,
        ProjectService.api.workPlaces({ projectId: $routeParams.projectId })
          .$promise,
        ProjectService.api.planFundsByYear({
          projectId: $routeParams.projectId,
        }).$promise,
        ProjectService.api.factFundsByYear({
          projectId: $routeParams.projectId,
        }).$promise,
        ProjectService.api.lands({ projectId: $routeParams.projectId })
          .$promise,
        ProjectService.api.maintenanceKinds({
          projectId: $routeParams.projectId,
        }).$promise,
        ProjectService.api.maintenances({ projectId: $routeParams.projectId })
          .$promise,
        ProjectService.api.okveds({ projectId: $routeParams.projectId })
          .$promise,
        ProjectService.api.outputs({ projectId: $routeParams.projectId })
          .$promise,
        ProjectService.api.progresses({ projectId: $routeParams.projectId })
          .$promise,
        ProjectService.api.subProgresses({ projectId: $routeParams.projectId })
          .$promise,
        ProjectService.api.chronologies({ projectId: $routeParams.projectId })
          .$promise,
        ProjectService.api.supports({ projectId: $routeParams.projectId })
          .$promise,
        Array.isArray($scope.project.placesMunicipality) &&
        $scope.project.placesMunicipality[0]
          ? InvestActivityService.api.get(
              $scope.project.placesMunicipality[0].id
            ).$promise
          : Promise.resolve({}),
      ]);

      $scope.project.projectStatus = statuses._embedded;
      if (
        $scope.project.projectStatus != null &&
        $scope.project.projectStatus.transitionDate != null
      ) {
        $scope.project.projectStatus.transitionDate = new Date(
          $scope.project.projectStatus.transitionDate
        );
      }
      if (
        Array.isArray(investActivityArea._embedded) &&
        Array.isArray($scope.project.placesMunicipality) &&
        $scope.project.placesMunicipality[0]
      ) {
        const investActivityAreas = investActivityArea._embedded.filter(
          (el) =>
            el.municipality &&
            el.municipality.id == $scope.project.placesMunicipality[0].id
        );
        $scope.project.investActivityArea = investActivityAreas[0];
      }

      $scope.project.projectContacts = projectContacts._embedded;
      $scope.project.projectFactFunds = projectFactFunds._embedded;
      $scope.project.projectPlanFunds = projectPlanFunds._embedded;
      $scope.project.projectTaxes = projectTaxes.items;
      $scope.project.projectWorkPlaces = projectWorkPlaces.items;
      $scope.project.projectPlanFundsByYear = projectPlanFundsByYear._embedded;
      $scope.project.projectFactFundsByYear = projectFactFundsByYear._embedded;
      $scope.project.projectLands = projectLands._embedded;
      $scope.project.projectMaintenanceKinds =
        projectMaintenanceKinds._embedded;

      $scope.project.projectMaintenances = projectMaintenances._embedded.map(
        (it) => {
          if (it.doneDatePlan) {
            it.doneDatePlan = new Date(it.doneDatePlan);
          }
          if (it.doneDateFact) {
            it.doneDateFact = new Date(it.doneDateFact);
          }
          if (it.startDateFact) {
            it.startDateFact = new Date(it.startDateFact);
          }
          return it;
        }
      );
      $scope.project.projectMaintenances =
        ProjectUtils.sortProjectMaintenancesByNpp(
          $scope.project.projectMaintenances
        );

      $scope.project.projectOkveds = projectOkveds._embedded;
      $scope.project.projectOutputs = projectOutputs._embedded;
      $scope.project.projectProgresses = projectProgresses._embedded
        .map((it) => {
          if (it.startDate) {
            it.startDate = new Date(it.startDate);
          }
          if (it.endDate) {
            it.endDate = new Date(it.endDate);
          }
          if (it.planStartDate) {
            it.planStartDate = new Date(it.planStartDate);
          }
          if (it.planEndDate) {
            it.planEndDate = new Date(it.planEndDate);
          }
          return it;
        })
        .sort((prevProgress, nextProgress) =>
          ProjectUtils.nppSort(prevProgress.phase, nextProgress.phase)
        );

      $scope.project.projectSubProgresses = projectSubProgresses.items.map(
        (it) => {
          if (it.startDate) {
            it.startDate = new Date(it.startDate);
          }
          if (it.endDate) {
            it.endDate = new Date(it.endDate);
          }
          if (it.planStartDate) {
            it.planStartDate = new Date(it.planStartDate);
          }
          if (it.planEndDate) {
            it.planEndDate = new Date(it.planEndDate);
          }
          return it;
        }
      );

      $scope.project.projectChronologies = chronologies.items.map((it) => {
        if (it.eventDate) {
          it.eventDate = new Date(it.eventDate);
        }
        return it;
      });

      $scope.project.projectSupports = projectSupports._embedded.map((it) => {
        if (it.startDate) {
          it.startDate = new Date(it.startDate);
        }
        return it;
      });

      processDates($scope.project);
      /**
       * Изменение $scope в async функции (load) отрабатывает вне digest-цикла.
       * Вручную указываем, что после выполнения функции finishLoad
       * необходимо выполнить $scope.$apply() с запуском digest-цикла.
       */

      $scope.$apply(() => finishLoad());
    }

    function processDates(project) {
      if (project.planStartYear) {
        const year = project.planStartYear;
        const [day, month] = (project.planStartDate || "01.01").split(".");
        project.planStartYear = new Date(year, month - 1, day);
      }
      if (project.planEndYear) {
        const year = project.planEndYear;
        const [day, month] = (project.planEndDate || "01.01").split(".");
        project.planEndYear = new Date(year, month - 1, day);
      }
      return project;
    }

    /**
     * Завершить загрузку
     */
    function finishLoad() {
      angular.copy($scope.project, $scope.oldProject);

      $rootScope.title = "";
      $scope.title = `Проект "${$scope.project.shortName}"`;

      if ($scope.project.author) {
        $scope.title += `<br />[${
          $scope.project.author.shortName
        }] ${getProjectAuthorRusProfileLink()}`;
      }

      isLoaded = true;
      $scope.loading = false;
    }

    /**
     * Получить html-элемент ссылки на профиль автора проекта на сайтe rusprofile.ru
     */
    function getProjectAuthorRusProfileLink() {
      return `
                <a 
                    href="${getProjectAuthorRusProfileUrl()}"
                    target="_blank"
                    rel="noopener noreferrer"
                    title="Информация об организации на сайте 'RUSPROFILE.RU'"
                >
                    <i 
                        class="fa fa-external-link project-title__icon" 
                        style="font-size: 18px;"
                    >
                    </i>
                </a>
            `;
    }

    /**
     * Получить URL на профиль автора проекта на сайте rusprofile.ru
     */
    function getProjectAuthorRusProfileUrl() {
      let queryString = $scope.project.author.inn
        ? $scope.project.author.inn
        : $scope.project.author.shortName;

      return `${RUS_PROFILE_URL}search?query=${encodeURIComponent(
        queryString
      )}`;
    }

    /**
     * Отменить изменения
     */
    function cancel() {
      angular.copy($scope.oldProject, $scope.project);
      $scope.project_form.$setPristine();
      $scope.edit = false;
      $scope.partialEdit = false;
    }

    /**
     * Сохранить
     */
    function save() {
      if (isLoaded && !angular.equals($scope.oldProject, $scope.project)) {
        if (!check($scope.project)) return;
        $scope.loading = true;

        let savingProject = toForm($scope.project);

        ProjectService.api.update(
          {
            projectId: $routeParams.projectId,
            transactionId: ProjectService.getTransactionId(),
          },
          { form: savingProject },
          (data) => {
            $scope.project = data._embedded;

            processProfitWorkPlaces($scope.project);

            angular.copy($scope.project, $scope.oldProject);
            let newPath = "/projects/" + $scope.project.id;
            if (!angular.equals($location.path(), newPath)) {
              ProjectService.edit($scope.project);
            } else {
              $scope.title = 'Проект "' + $scope.project.shortName + '"';
              $scope.project_form.$setPristine();
              load();
            }
            $scope.edit = false;
            $scope.partialEdit = false;
            getSignErrors();
            Notification.success({
              message: "Изменения сохранены!",
            });
          },
          (e) => {
            $log.debug("PROJECT:SAVE:ERROR: ", e);

            Notification.warning({
              title: "Внимание!",
              message: "Ошибка сохранения",
            });

            $scope.loading = false;
          }
        );
      } else {
        $scope.edit = false;
        $scope.partialEdit = false;
        Notification.success({
          message: "Изменения сохранены!",
        });
      }
    }

    /**
     * Обработка значений "Количество создаваемых рабочих мест" и "в том числе для иностр. сотрудников".
     * Если приходит null, то проставляем значение 0 для вывода на фронте.
     * @param project
     */
    function processProfitWorkPlaces(project) {
      project.profitPlanWplaces = !!project.profitPlanWplaces
        ? project.profitPlanWplaces
        : 0;

      project.profitForeignWorkPlaces = !!project.profitForeignWorkPlaces
        ? project.profitForeignWorkPlaces
        : 0;
    }

    /**
     * Проверка полей проекта
     * @param {*} project
     * @return {boolean}
     */
    function check(project) {
      if (
        project.projectStatus === undefined ||
        project.projectStatus === null ||
        angular.equals({}, project.projectStatus)
      ) {
        Notification.warning({
          title: "Внимание!",
          message: "Статус сопровождения обязателен для заполнения.",
        });

        return false;
      }

      return true;
    }

    // endregion

    // region Уход со страницы: проверка на внесение изменений

    $timeout(startWatchingForLocationChanges, 0, false);
    let stopWatchingLocation = null;

    /**
     * Слушаем изменения пути
     * @param {*} event
     */
    function handleLocationChangeStartEvent(event) {
      if (isLoaded && !angular.equals($scope.oldProject, $scope.project)) {
        event.preventDefault();

        let targetPath = $location.path();
        let targetSearch = $location.search();
        let targetHash = $location.hash();

        ModalService.warning({
          message:
            "Данные не сохранены! Вы действительно желаете покинуть данную страницу?",
          apply: "Да",
          cancel: "Нет",
        }).result.then(function () {
          $location.path(targetPath).search(targetSearch).hash(targetHash);

          stopWatchingLocation();

          $scope.$applyAsync(startWatchingForLocationChanges);
        });
      }
    }

    /**
     * Подписываемся на изменения пути
     */
    function startWatchingForLocationChanges() {
      stopWatchingLocation = $scope.$on(
        "$locationChangeStart",
        handleLocationChangeStartEvent
      );
    }

    // endregion
  },
];
